<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-8 col-md-7 col-7 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">Report Group</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-5 col-5 d-flex justify-content-end">
      </div>
    </div>

    <div class="page-header align-items-start min-vh-100">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto">
            <div class="d-flex justify-content-between mt-3">
              <input
                class="nosubmit"
                type="search"
                id="keyword_search"
                extraClass
                name="keyword_search"
                placeholder="Search ..."
                v-model="search_keyword"
                @input="onChangesearchKeyword"
              />
            </div>
            <div class="mt-3">
              <div style="margin-top: 15px; margin-bottom: 50px">
                <div class="d-flex m-content" v-if="typeList.length">
                  <!-- Left Menu - Type List -->
                  <div class="m-left-menu">
                    <div class="d-flex justify-content-between">
                      <h3 class="title-page">Report Type</h3>
                    </div>

                    <!-- Desktop view -->
                    <div class="d-none d-md-block">
                      <div
                        v-for="(type, index) in typeList"
                        :key="type.id"
                      >
                        <div
                          :class="{
                            hovered: typeHoveredRow === index,
                          }"
                          @mouseenter="typeHoveredRow = index"
                          @mouseleave="typeHoveredRow = null"
                          :style="getStyleType(index, type.id)"
                          class="d-flex align-items-center"
                          style="justify-content: space-between;"
                        >
                          <div
                            style="width: 100%"
                            @click="selectType(type)"
                          >
                            <div class="d-flex align-items-center">
                              <div>{{ type.group_name }}</div>
                            </div>
                          </div>

                          <div
                            class="dropdown"
                            style="width: 15%; text-align: end"
                          >
                            <i
                              class="fas fa-pencil-alt"
                              @click="addGroupAndType(true, type.id)"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div
                            class="dropdown"
                            style="width: 15%; text-align: end"
                          >
                            <i
                              class="far fa-trash-alt"
                              @click="deleteGroupAndType(true, type.id)"
                              aria-hidden="true"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div :style="getStyleType(1, -1)" class="pt-3 pb-3 d-none d-md-block">
                      <material-button
                        @click="addGroupAndType(true)"
                        class="btn btn-sm btn-background"
                      >
                        <i class="material-icons css-icon">addoutlined</i>
                        ADD TYPE
                      </material-button>
                    </div>

                    <!-- Mobile view -->
                    <div class="d-block d-md-none">
                      <div class="mobile-categories-scroll">
                        <div
                          v-for="type in typeList"
                          :key="type.id"
                          class="mobile-category-item"
                          :class="{
                            'active': typeIdSelectToHilight === type.id,
                          }"
                          @click="selectType(type)"
                        >
                          <div class="mobile-category-name">
                            {{ type.group_name }}
                          </div>
                        </div>
                      </div>
                      <div class="mobile-add-category mt-3">
                        <material-button
                          @click="addGroupAndType(true)"
                          class="btn btn-sm btn-background w-100"
                        >
                          <i class="material-icons css-icon">addoutlined</i>
                          ADD TYPE
                        </material-button>
                      </div>
                    </div>
                  </div>

                  <!-- Right Menu - Group Details -->
                  <div
                    class="m-right-menu"
                    v-if="typeList && typeList.length && selectedTypeData"
                  >
                    <div class="d-flex justify-content-between">
                      <h3 class="title-page">Groups by {{ selectedTypeData.group_name }}</h3>
                    </div>
                    <div
                      class="table-responsive p-0"
                      style="
                        margin-bottom: 50px;
                        border: 1px solid #ccc;
                      "
                    >
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-center">Group Name</th>
                            <th></th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody v-if="selectedTypeData.groups && selectedTypeData.groups.length">
                          <tr
                            v-for="(group, index) in selectedTypeData.groups"
                            :key="group.id"
                            :class="{
                              hovered: groupHoveredRow === index,
                            }"
                            @mouseenter="groupHoveredRow = index"
                            @mouseleave="groupHoveredRow = null"
                            style="cursor: pointer"
                          >
                            <td class="text-start ps-3" style="color: black;">
                              {{ group.group_name }}
                            </td>
                            <td class="text-end">
                              <a
                                class="btn btn-link text-dark px-2 mb-0"
                                @click="addGroupAndType(false, group.id)"
                              >
                                <i
                                  class="fas fa-pencil-alt text-dark me-2"
                                  aria-hidden="true"
                                ></i
                                >Edit
                              </a>
                              <a
                                class="btn btn-link text-danger text-gradient px-3 mb-0"
                                href="javascript:;"
                                @click="deleteGroupAndType(false, group.id)"
                              >
                                <i
                                  class="far fa-trash-alt me-2"
                                  aria-hidden="true"
                                ></i
                                >Delete
                              </a>
                            </td>
                            <td class="text-end"> </td>
                          </tr>
                          <tr>
                            <td colspan="3" class="text-start pt-3">
                              <material-button
                                @click="addGroupAndType(false, selectedTypeData.id, true)"
                                class="btn btn-sm btn-background"
                              >
                                ADD GROUP
                              </material-button>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="3" class="text-center">
                              No groups available
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3" class="text-start pt-3">
                              <material-button
                                @click="addGroupAndType(false, selectedTypeData.id, true)"
                                class="btn btn-sm btn-background"
                              >
                                ADD GROUP
                              </material-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div v-else class="mt-3 category-box">
                  <div
                    class="d-flex align-items-center cursor-pointer"
                    @click="addGroupAndType(true)"
                  >
                    <i class="material-icons-round opacity-10">addoutlined</i>
                    <div class="mt-1">Add Report Type</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="position-fixed top-1 end-1 z-index-2 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>

    <material-loading :active="loaderActive" />

    <ModalConfirmDelete
      message="Are you sure you want to delete?"
      :process-yes="handleDeleteGroupType"
    />

    <AddGroupAndTypeModal
      :keyReload="keyReloadAddGroupAndType"
      :idSelected="idSelected"
      :isType="isType"
      :isAddGroup="isAddGroup"
      @reload-data="reloadData"
    ></AddGroupAndTypeModal>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import MaterialButton from "@/components/MaterialButton.vue";
import ReportGroupService from "../../services/product/reportGroup.service";
import $ from "jquery";
import ModalConfirmDelete from "@/components/ModalConfirmDelete.vue";
import AddGroupAndTypeModal from "@/components/AddGroupAndType.vue";

export default {
  name: "ReportGroupNew",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    ModalConfirmDelete,
    AddGroupAndTypeModal,
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      isLoadData: true,
      typeList: [],
      isType: true,
      idSelected: 0,
      isAddGroup: false,
      search_keyword: "",
      searchTimerId: null,
      keyReloadAddGroupAndType: "key-reload-add-group-and-type",
      // Highlight states
      typeIdSelectToHilight: 0,
      groupIdSelectToHilight: 0,
      typeHoveredRow: null,
      groupHoveredRow: null,
      selectedTypeData: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    selectType(type) {
      this.typeIdSelectToHilight = type.id;
      this.groupIdSelectToHilight = 0;
      this.selectedTypeData = type;
    },

    selectGroup(group) {
      this.groupIdSelectToHilight = group.id;
    },

    addGroupAndType(isType, idSelected = 0, isAddGroup = false) {
      this.isType = isType;
      this.idSelected = idSelected;
      this.isAddGroup = isAddGroup;
      this.keyReloadAddGroupAndType = Math.random();
      $("#show-modal-add-group-and-type").click();
    },

    deleteGroupAndType(isType, idSelected = 0) {
      this.isType = isType;
      this.idSelected = idSelected;
      $(".btn-confirm-modal-delete").click();
    },

    reloadData(mess) {
      this.snackbar = "success";
      this.message = mess;
      this.isType = true;
      this.idSelected = 0;
      this.isAddGroup = false;
      this.setTimeOutNotification();
      this.getList();
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    getList() {
      this.isLoadData = false;
      this.showLoader();
      var dataForm = {
        keyword: this.search_keyword,
      };
      ReportGroupService.getList(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.typeList = response.data.data;
            this.isLoadData = true;
            // Select first type by default
            if (this.typeList.length > 0) {
              this.selectType(this.typeList[0]);
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
      this.hideLoader();
    },

    handleDeleteGroupType() {
      this.showLoader();
      ReportGroupService.delete(this.idSelected).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.reloadData(
              "Deleted " + (this.isType ? "type" : "group") + " successfully"
            );
            $(".btn-close-modal").click();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    onChangesearchKeyword(event) {
      this.search_keyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getList();
      }, 1000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    getStyleType(index, typeId) {
      let isHighlighted = this.typeIdSelectToHilight === typeId;

      return {
        justifyContent: "space-between",
        alignItems: "center",
        display: "flex",
        width: "100%",
        border: "#ccc",
        background: isHighlighted ? "#1871bd !important" : "white",
        color: isHighlighted ? "white" : "black",
        paddingLeft: "10px",
        paddingRight: "10px",
        paddingTop: "5px",
        paddingBottom: "5px",
        borderTop: index == 0 ? "1px solid #ccc" : "none",
        borderBottom: "1px solid #ccc",
        borderLeft: "1px solid #ccc",
        borderRight: "1px solid #ccc",
        cursor: "pointer",
      };
    },

    getStyleGroup(groupId) {
      let isHighlighted = this.groupIdSelectToHilight === groupId;

      return {
        justifyContent: "space-between",
        alignItems: "center",
        display: "flex",
        width: "100%",
        background: isHighlighted ? "#1871bd" : "white",
        color: isHighlighted ? "white" : "black",
        paddingLeft: "5px",
        paddingRight: "10px",
        paddingTop: "5px",
        paddingBottom: "5px",
        borderBottom: "1px solid #ccc",
        borderLeft: "1px solid #ccc",
        borderRight: "1px solid #ccc",
        cursor: "pointer",
      };
    },
  },
};
</script>

<style scoped>
.css-icon {
  position: absolute;
  left: 17px !important;
  font-size: 18px !important;
  top: 7px !important;
}

.mobile-categories-scroll {
  display: flex;
  overflow-x: auto;
  gap: 20px;
  padding: 10px 0;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.mobile-categories-scroll::-webkit-scrollbar {
  display: none;
}

.mobile-category-item {
  flex: 0 0 auto;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.mobile-category-item.active {
  color: #007bff;
  border-bottom: #007bff 3px solid;
}

.mobile-category-name {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.category-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px;
  border: 1px solid #d5d6d8;
  color: #133067;
  border-radius: 5px;
}

.category-box:last-child {
  margin-bottom: 50px;
}

.cl-22 {
  color: #222 !important;
}

.m-left-menu {
  width: 280px !important;
  min-width: 280px !important;
  margin-right: 24px;
}

.m-right-menu {
  width: calc(100% - 280px - 24px);
}

.hovered {
  background-color: #f5f5f5 !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.title-page {
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin: 0;
  padding: 10px 0;
}

.dropdown-menu {
  border: 1px solid #d5d6d8;
  min-width: 9rem;
}

.dropdownMenuButton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 30px;
  cursor: pointer;
}

.dropdown-item {
  display: flex;
  align-items: center;
}

.page-header .container {
  color: #222 !important;
}

.page-header .mask {
  z-index: -1 !important;
}

@media (max-width: 768px) {
  .m-content {
    flex-direction: column !important;
  }

  .m-right-menu {
    width: 100% !important;
    margin-top: 15px !important;
  }

  .m-left-menu {
    width: 100% !important;
    margin-right: 0 !important;
  }
}

.d-flex {
  display: flex;
}

.gap-2 {
  gap: 0.5rem;
}

table tbody tr:hover {
  background-color: #f5f5f5;
}

table.table {
  margin-bottom: 0;
}

.text-xss {
  font-size: 0.875rem;
}

.text-end {
  text-align: end;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  max-width: 350px;
  border-bottom: 1px solid #d2d2d2;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  width: 100%;
  padding: 9px 4px 9px 40px;
  outline: none;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

</style>